import React from "react";
import { Flex } from "@chakra-ui/react";
import CustomIcon, { AssetTypes } from "../../../../../../../public/icons-v1_1";

interface ActionIconBoxProps {
  src: AssetTypes;
  icoSize?: number;
}

// 액션 패널 각 행 좌측의 아이콘 박스 — 연동/주문 행 공용
const PathPickBasketActionIconBox = ({
  src,
  icoSize = 16,
}: ActionIconBoxProps) => {
  return (
    <Flex
      boxSize={"32px"}
      alignItems={"center"}
      justifyContent={"center"}
      border={"0.5px solid #D4D4D1"}
      borderRadius={"8px"}
      background={"#F7F9FA"}
      flexShrink={0}
    >
      <CustomIcon
        src={src}
        width={icoSize}
        height={icoSize}
        color={"#005AAD"}
      />
    </Flex>
  );
};

export default PathPickBasketActionIconBox;
